import { UserInfo } from '../account/account-rest-interface';

export function isFreeTrialUser(user: UserInfo) {
    if (user.bundleId === 'freeTrial') {
        return true;
    } else {
        return false;
    }
}